export default {
    path: "/home",
    meta: { label: "Fraud Management" },
    component: {
        render(c) {
            return c("router-view");
        },
    },
    children: [
        {
            path: "/fraudManagement/dashboard",
            meta: {
                requiresAuth: true,
                label: "Fraud Monitoring Dashboard"
            },
            component: () => import("@/views/fraudManagement/Dashboard.vue"),
        },
        {
            path: "/fraudManagement/alertDetails/:id",
            name: "AlertDetails",
            meta: {
                requiresAuth: true,
                label: "Alert Details"
            },
            component: () => import("@/views/fraudManagement/alertDetails.vue"),
        },
        {
            path: "/fraudManagement/suspiciousTransaction",
            meta: {
                requiresAuth: true,
                label: "Suspicious Transaction"
            },
            component: () => import("@/views/fraudManagement/SuspiciousTransaction.vue"),
        },
        {
            path: "/fraudManagement/fraudAlert",
            meta: {
                requiresAuth: true,
                label: "Fraud Alert"
            },
            component: () => import("@/views/fraudManagement/FraudAlert.vue"),
        },
        {
            path: "/fraudManagement/customerSellerBlacklist",
            meta: {
                requiresAuth: true,
                label: "User Blacklist"
            },
            component: () => import("@/views/fraudManagement/CustomerAndSellerBlacklist.vue"),
        },
        {
            path: "/fraudManagement/returnAbuseReport",
            meta: {
                requiresAuth: true,
                label: "Return Abuse Report"
            },
            component: () => import("@/views/fraudManagement/ReturnAbuseReport.vue"),
        },
    ],
};